module.exports = __webpack_public_path__ + "img/Group796.4549be8d.png";